import { StandardEvents } from '@shopify/events';
import '@theme/theme-drawer';

function updateCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-nc-cart-count]').forEach((bubble) => {
    bubble.textContent = String(count);
    bubble.hidden = count === 0;
    const link = bubble.closest('[data-nc-cart]');
    if (link) link.setAttribute('aria-label', `${link.dataset.cartLabel} (${count})`);
  });
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    if (detail?.didError) return;
    const count = cart?.totalQuantity ?? detail?.itemCount;
    updateCount(count);
  }).catch(() => {});
});

document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-nc-cart]');
  if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer || typeof drawer.open !== 'function') return;
  event.preventDefault();
  drawer.open();
});
